import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useBrandsApi() {
    const callApi = useApiCall();

    return {
        addUpdateBrand: apiCaller(callApi, SAGA_ACTIONS.BRANDS.ADD_UPDATE_BRAND),
        deleteBrand: apiCaller(callApi, SAGA_ACTIONS.BRANDS.DELETE_BRAND),
        searchBrand: apiCaller(callApi, SAGA_ACTIONS.BRANDS.SEARCH_BRAND),
        brandDetails: apiCaller(callApi, SAGA_ACTIONS.BRANDS.BRAND_DETAILS),
    };
}
